import {ModelWithParent} from "FormBuilder/Core/Models/ModelWithParenth";
import {FBFieldWithPriceBaseOptions} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {FBFieldBaseOptions} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {CalculatorBase} from "FormBuilder/Core/Calulators/CalculatorBase";
import {CalculatorFactory} from "FormBuilder/Core/Calulators/CalculatorFactory";
import {FBMultipleOptionsBaseOptions} from "FormBuilder/Fields/Core/FBMultipleOptionsBase.Options";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {OptionsCalculator} from "FormBuilder/Core/Calulators/OptionsCalculator";
import {OptionItem} from "FormBuilder/Fields/Options/OptionItem";
import {NumericUtilities} from "FormBuilder/Utilities/NumericUtilities";

export abstract class FBMultipleOptionsBaseModel<Op extends FBMultipleOptionsBaseOptions=FBMultipleOptionsBaseOptions,P extends FBColumnModel=FBColumnModel> extends FBFieldWithPriceBaseModel<Op,P>{
    SelectedValues:number[];

    public ToggleSelection(optionId: number, checked: boolean) {
        let option=this.Options.Options.find(x=>x.Id==optionId);
        if(option==null)
            return;

        let items=this.SelectedValues.slice(0);
        if(!this.AllowMultiple)
            items=[];
        if(checked&&items.indexOf(option.Id)==-1)
            items.push(option.Id);
        if(!checked&&items.indexOf(option.Id)>=0)
            items.splice(items.indexOf(option.Id),1);


        if(items.length>0)
            this.RemoveError('required');

        this.SelectedValues=items;

        this.Quantity=items.length>0&&this.Quantity==0?1:this.Quantity;
        this.FireValueChanged();
    }

    public get AllowMultiple(){
        return true;
    }

    protected InitializePriceCalculator() {
        this.calculator=new OptionsCalculator();
        this.calculator.Initialize(this);
    }
    public RecreateSelectedOptions(){
        this.SelectedValues=this.Options.Options.filter(x=>x.Selected).map(x=>x.Id);
    }

    InitializeStartingValues() {
        let selectedValues=this.Options.Options.filter(x=>x.Selected).map(x=>x.Id);
        if(this.GetPreviousData()!=null)
        {
            let previousSelectedValues:any[]=this.GetPreviousDataProperty('SelectedValues',[]);
            selectedValues=this.Options.Options.filter(x=>previousSelectedValues.some(y=>y.Id==x.Id)).map(x=>x.Id);

        }

        this.SelectedValues=selectedValues;
        this.Quantity=this.GetPreviousDataProperty( 'Quantity',this.ParseNumber(this.Options.QuantityDefaultValue));
    }

    protected InternalSerialize(obj: any) {
        super.InternalSerialize(obj);
        obj.SelectedValues=this.GetSelectedOptions().map(x=>x.ToObject());
        for(let i=0;i<obj.SelectedValues.length;i++)
        {

            let total:any=(this.calculator as OptionsCalculator).OptionsTotal.find(x=>x.Id==obj.SelectedValues[i].Id);
            if(total==null)
                total={
                    Id:obj.SelectedValues[i].Id,
                    Price:0,
                    Quantity:0,
                    RegularPrice:0,
                    SalePrice:0,
                    Total:0
                };

            obj.SelectedValues[i]=Object.assign(obj.SelectedValues[i],total);
        }
    }




    GetStoresInformation(): boolean {
        return true;
    }


    GetSelectedOptions():OptionItem[]{
        if(!this.GetIsVisible())
            return [];
        return this.Options.Options.filter(x=>this.SelectedValues.some(y=>y.toString()==x.Id.toString()));
    }

    GetIsUsed(): boolean {
        if(!super.GetIsUsed())
            return false;
        return this.SelectedValues.length>0;
    }

    GetValue() {
        if(!this.GetIsVisible())
            return [];
        return this.SelectedValues;
    }

    GetColumnValue(columnNameOrId:string)
    {
        let selectedOptions=this.GetSelectedOptions();
        let columnToSearch=this.Options.AdditionalOptionColumn.find(x=>x.Id==columnNameOrId as any||x.Label==columnNameOrId);
        if(columnToSearch==null)
            return null;

        let columnValues=[];
        selectedOptions.forEach(option=>{
            let columnValue=option.AdditionalOptionValue.find(x=>x.Id==columnToSearch.Id);
            if(columnValue!=null)
                columnValues.push(columnValue.Value);
        });

        if(columnValues.length==0)
            return null;

        return columnValues;

    }

    GetPrice(): number | number {
        return this.GetSelectedOptions().reduce((previousValue, currentValue) => NumericUtilities.ParseNumber(currentValue.RegularPrice,0)+previousValue,0);
    }

    GetText(): string {
        return this.GetSelectedOptions().map(x=>x.Label).join(', ');
    }
}